import React from "react";

import { Toolbar, Typography } from "@mui/material";
import { ChartOptions } from "chart.js";
import classnames from "classnames";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import { QuoteStatuses } from "../../../../../../types";
import { Chart as ChartComponent, ChartType } from "../../../../../Generic/Chart";
import NoDataLabel from "../../../../NoDataLabel";
import { useStyles } from "./styles";

type Props = {
  quoteStatuses?: QuoteStatuses;
};

const StatusBarChart = (props: Props) => {
  const { quoteStatuses } = props;

  const classes = useStyles();

  const { t: translate } = useTranslation();

  const labels: string[] = [
    translate("won"),
    translate("lost"),
    translate("cancelled"),
    translate("draft"),
    translate("pending"),
    translate("inspect"),
  ];

  const renderContent = () => {
    if (!quoteStatuses || !quoteStatuses?.total || quoteStatuses?.total === 0)
      return <NoDataLabel />;

    return (
      <div className={classes.mainDiv}>
        <ChartComponent
          chartType={ChartType.BAR}
          data={{
            labels,
            datasets: [
              {
                data: [
                  quoteStatuses?.won,
                  quoteStatuses?.lost,
                  quoteStatuses?.cancelled,
                  quoteStatuses?.draft,
                  quoteStatuses?.pending,
                  quoteStatuses?.inspect,
                ],
                backgroundColor: ["#2E65F3", "#DCECFB", "#F97066", "#39E27C", "#FDB022", "#36BFFA"],
                borderColor: ["#2E65F3", "#DCECFB", "#F97066", "#39E27C", "#FDB022", "#36BFFA"],
                borderWidth: 1,
                maxBarThickness: 45,
              },
            ],
          }}
          graphOptions={
            {
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: false,
                },
                zoom: {
                  zoom: {
                    enabled: true,
                    mode: "x",
                    drag: {
                      enabled: true,
                    },
                    wheel: {
                      enabled: true,
                    },
                  },
                },
              },
            } as ChartOptions<"bar">
          }
        />
        <div className={classes.footer}>
          <span className={classes.infoText}>
            {translate("lastUpdatedOn")}: <b>{format(new Date(), "MMM dd, yyyy")}</b>
          </span>
          <span data-cy="totalQuotes" className={classnames(classes.infoText, classes.total)}>
            {translate("totalQuotes")} <b className={classes.totalText}>{quoteStatuses?.total}</b>
          </span>
        </div>
      </div>
    );
  };

  return (
    <>
      <Toolbar className={classes.toolbar} variant="dense">
        <Typography className={classes.title} color="textSecondary" data-cy="ordersByType">
          {translate("quotesStatus")}
        </Typography>
      </Toolbar>
      {renderContent()}
    </>
  );
};

export default StatusBarChart;
